import React from "react";
import TableHeaders from "./TableHeaders";

export default function CamvioTable2({
  headerDefs,
  sortFunction,
  sortField,
  sortDirection,
  children,
  style
}) {
  return (
    <div className="cmv-container-table">
      <table className={`table cmv-table cmv-table-mobile ${!style ? "cmv-table-solid" : "cmv-table-striped"}`}>
        <TableHeaders
          headerDefs={headerDefs}
          onSortChange={sortFunction}
          sortField={sortField}
          sortDirection={sortDirection}
        />
        {children}
      </table>
    </div>
  );
}
